import Factory from '../factory';

const schema = Factory.schema('pullout');
const attributes = schema.getProp('attributes').getValue();

attributes.prop('title').setType(String).setValue('Title');
attributes.prop('text').setType(String).setValue('Text...');
attributes.prop('image').setType(String).setValue('image-placeholder.svg');
attributes.prop('imageAlt').setType(String);
attributes.prop('imageCaption').setType(String);
attributes.prop('flip').setType(Boolean).setValue(false);

export default schema;
